/**
 * <product-recommendations> - PDP'ens "ofte stylet med"-raekke (Figma-paritet
 * P9). Shopifys recommendations beregnes foerst efter request-tid, saa
 * raekken MAA klient-hentes: naar sektionen naermer sig viewporten fetches
 * routes.product_recommendations_url med section_id, og serverens HTML
 * swappes ind (Section Rendering-moensteret - penge/locale forbliver
 * server-ejet, ingen klient-templating).
 *
 * Progressiv: uden JS renderes intet (raekken er berigelse, ikke indhold);
 * fejl efterlader sektionen tom og stille.
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        io.disconnect();
        this.load();
      },
      { rootMargin: '400px 0px' },
    );
    io.observe(this);
  }

  async load() {
    this.dataset.loaded = 'true';
    try {
      const response = await fetch(this.dataset.url);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('product-recommendations');
      if (fresh && fresh.innerHTML.trim() !== '') {
        this.innerHTML = fresh.innerHTML;
        /* Signalet til CSS'en om at vaerten nu har indhold. En attribut og ikke
           :empty: WebKit genberegner ikke `:has(> x:empty)` naar boern
           indsaettes via innerHTML, saa wrapperen blev staaende absolut og
           lagde sig oven paa koebspanelet i Safari (maalt 2026-10-06). */
        this.removeAttribute('data-empty');
      }
    } catch (e) {
      /* netvaerksfejl: raekken forbliver tom - bevidst stille */
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
